/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlPolicy
 */
export interface ControlPolicy {
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    account_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    policy_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    policy_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    broker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    broker_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    broker_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    agency_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    agency_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    retail_broker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    retail_broker_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    policyholder_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    policyholder_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    policyholder_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    policyholder_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    industry_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    n_employees?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    pii_phi_count?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    company_revenue?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    aggregate_limit?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    effective_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPolicy
     */
    account_line_uuid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlPolicy
     */
    is_excess?: boolean;
}

/**
 * Check if a given object implements the ControlPolicy interface.
 */
export function instanceOfControlPolicy(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPolicyFromJSON(json: any): ControlPolicy {
    return ControlPolicyFromJSONTyped(json, false);
}

export function ControlPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPolicy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_uuid': !exists(json, 'account_uuid') ? undefined : json['account_uuid'],
        'policy_number': !exists(json, 'policy_number') ? undefined : json['policy_number'],
        'policy_uuid': !exists(json, 'policy_uuid') ? undefined : json['policy_uuid'],
        'broker_name': !exists(json, 'broker_name') ? undefined : json['broker_name'],
        'broker_email': !exists(json, 'broker_email') ? undefined : json['broker_email'],
        'broker_uuid': !exists(json, 'broker_uuid') ? undefined : json['broker_uuid'],
        'agency_name': !exists(json, 'agency_name') ? undefined : json['agency_name'],
        'agency_uuid': !exists(json, 'agency_uuid') ? undefined : json['agency_uuid'],
        'retail_broker_name': !exists(json, 'retail_broker_name') ? undefined : json['retail_broker_name'],
        'retail_broker_email': !exists(json, 'retail_broker_email') ? undefined : json['retail_broker_email'],
        'policyholder_name': !exists(json, 'policyholder_name') ? undefined : json['policyholder_name'],
        'policyholder_email': !exists(json, 'policyholder_email') ? undefined : json['policyholder_email'],
        'policyholder_uuid': !exists(json, 'policyholder_uuid') ? undefined : json['policyholder_uuid'],
        'policyholder_phone': !exists(json, 'policyholder_phone') ? undefined : json['policyholder_phone'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'industry_name': !exists(json, 'industry_name') ? undefined : json['industry_name'],
        'n_employees': !exists(json, 'n_employees') ? undefined : json['n_employees'],
        'pii_phi_count': !exists(json, 'pii_phi_count') ? undefined : json['pii_phi_count'],
        'company_revenue': !exists(json, 'company_revenue') ? undefined : json['company_revenue'],
        'aggregate_limit': !exists(json, 'aggregate_limit') ? undefined : json['aggregate_limit'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'effective_date': !exists(json, 'effective_date') ? undefined : json['effective_date'],
        'end_date': !exists(json, 'end_date') ? undefined : json['end_date'],
        'account_line_uuid': !exists(json, 'account_line_uuid') ? undefined : json['account_line_uuid'],
        'is_excess': !exists(json, 'is_excess') ? undefined : json['is_excess'],
    };
}

export function ControlPolicyToJSON(value?: ControlPolicy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_uuid': value.account_uuid,
        'policy_number': value.policy_number,
        'policy_uuid': value.policy_uuid,
        'broker_name': value.broker_name,
        'broker_email': value.broker_email,
        'broker_uuid': value.broker_uuid,
        'agency_name': value.agency_name,
        'agency_uuid': value.agency_uuid,
        'retail_broker_name': value.retail_broker_name,
        'retail_broker_email': value.retail_broker_email,
        'policyholder_name': value.policyholder_name,
        'policyholder_email': value.policyholder_email,
        'policyholder_uuid': value.policyholder_uuid,
        'policyholder_phone': value.policyholder_phone,
        'locale': value.locale,
        'industry_name': value.industry_name,
        'n_employees': value.n_employees,
        'pii_phi_count': value.pii_phi_count,
        'company_revenue': value.company_revenue,
        'aggregate_limit': value.aggregate_limit,
        'country': value.country,
        'effective_date': value.effective_date,
        'end_date': value.end_date,
        'account_line_uuid': value.account_line_uuid,
        'is_excess': value.is_excess,
    };
}

